/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'http-method-match-with-objects';
const prefix = `${moduleName}.${componentName}`;

export const methodLabel = `${prefix}.methodLabel`;
export const methodPlaceholder = `${prefix}.methodPlaceholder`;

export const ENGLISH = {
    [methodLabel]: 'Method',
    [methodPlaceholder]: 'Select Method',
};
